import styled, { css } from 'styled-components'

import { isDesktop } from 'utils/device'

import { RedButtonOnDisable } from '../styles'

export const Tooltip = styled.div`
    background: #333333;
    color: white;
    font: 0.875 Avenir;
    vertical-align: center;
    padding: 12px;
    text-align: center;
    border-radius: 10px;
    margin-right: 12px;
    display: none;
    align-items: center;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    position: fixed;
    right: 3.5vw;
    top: 10vh;
    width: 10vw;

    @media only screen and (max-width: 1440px) {
        width: 12vw;
        top: 10vh;
        right: 5vw;
    }
    @media only screen and (max-width: 1366px) {
        width: 13vw;
        top: 7.5vh;
        right: 5vw;
    }

    @media only screen and (max-width: 1024px) {
        width: 13vw;
        top: 9vh;
        right: 6vw;
    }

    @media only screen and (max-width: 992px) {
        width: 20vw;
        left: 5vw;
        top: 75vh;
    }
    @media only screen and (max-width: 800px) {
        width: 22vw;
        left: 5vw;
        top: 77vh;
    }
    @media only screen and (max-width: 700px) {
        top: 74vh;
        width: 26vw;
    }
    @media only screen and (max-width: 600px) {
        top: 70vh;
        width: 29vw;
    }
`

export const BtnWrapper = styled.div`
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    ${isDesktop &&
        css`
            width: 35px;
            height: 35px;
            margin-top: 12px;
        `}
    ${props => props.disabled && 'cursor:  not-allowed;'}
`

export const AnimWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
`

export const Button = styled(RedButtonOnDisable)`
    position: absolute;
    margin: 0 !important;
    top: 0 !important;
    right: 0 !important;
`
